export default __webpack_public_path__ + "static/spacing-tokens-light-21ba5d7d3395cca6e27f2f299262927b.png";